module.exports = __webpack_public_path__ + "static/media/DSC09968.f81fed72.jpg";